import { useMemo } from "react";
import { string, object } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { DescriptionModes } from "@repo/utils";
import { TABLE_DRAGGABLE_CONTAINER } from "@utils";
import {
  useEstimateStructure,
  usePresetFieldNames,
  HeaderRow,
  PinnableCell,
  useEstimateEditorSettings, useEstimateTableSettings,
} from "@tools";
import Grid from "@material-ui/core/Grid";
import { BudgetTrackingHeaderWorkType } from "./components/BudgetTrackingHeaderWorkType";
import classnames from "classnames";

export const BudgetTrackingTableHeader = observer(({
  section,
  tableIdentifier,
}) => {
  const { isProposal, blockExpansions } = useEstimateEditorSettings();
  const { useExpandCell } = useEstimateTableSettings();
  const structure = useEstimateStructure();
  const { settings } = structure;

  const {
    viewLevel,
    showBreakdownColumns,
    descriptionMode,
  } = settings;

  const {
    btTaskWorkTypes,
    allChildrenExpanded,
    sectionModulesHaveChildren,
    isOpened,
  } = section;

  const { t } = useTranslation();
  const { getFieldName } = usePresetFieldNames(isProposal);

  const expanded = useMemo(() => (
    isOpened && allChildrenExpanded
  ), [allChildrenExpanded, isOpened]);
  
  const expandAllChildren = () => section.expandAllChildren(!expanded);

  const handleDescriptionCellRescale = (w) => {
    structure.settings.setDescriptionCellWidth(w);
  };
  return (
    <HeaderRow
      id={tableIdentifier}
      useExpandCell={useExpandCell}
      expandable={!blockExpansions && viewLevel > 1}
      expanded={expanded}
      onExpand={expandAllChildren}
      altBackground
    >
      <PinnableCell
        allowOverflowDisplay={descriptionMode < DescriptionModes.COLUMN}
        keepMinSize
        pinnedLeft={!isProposal || sectionModulesHaveChildren ? 1 : 0}
      >
        <span className="preset-tableHeader pt-module">
          {getFieldName("pt-module")}
        </span>
      </PinnableCell>

      <PinnableCel
        isHeader
        keepMinSize
        setWidth={handleDescriptionCellRescale}
      >
        <span className="preset-tableHeader ml-0-5">{t("common.desc")}</span>
      </PinnableCel>

      <Grid
        className={classnames(TABLE_DRAGGABLE_CONTAINER, "wt-container")}
        item
        container
        wrap="nowrap"
        alignItems="center"
        style={{ width: "initial" }}
      >
        {showBreakdownColumns &&
          btTaskWorkTypes?.map((workType) => (
            <BudgetTrackingHeaderWorkType
              key={workType.id}
              workType={workType}
              section={section}
            />
          ))}
      </Grid>
    </HeaderRow>
  );
});

BudgetTrackingTableHeader.propTypes = {
  section: object.isRequired,
  tableIdentifier: string.isRequired,
};
